import * as React from "react";
import { observer } from "mobx-react-lite";

const DeliveryContext = React.createContext<{ placeId: string }>(null!);

export function DeliveryProvider({
	children,
	placeId,
}: {
	children: React.ReactNode;
	placeId: string;
}) {
	return (
		<DeliveryContext.Provider value={{ placeId }}>{children}</DeliveryContext.Provider>
	);
}

export const useDeliveryContext = () => {
	const context = React.useContext(DeliveryContext);
	if (!context) {
		throw new Error("useDeliveryContext must be used within a DeliveryLayout");
	}
	return context;
};

interface DeliveryLayoutProps {
	params: {
		placeId: string;
	};
}

function DeliveryLayout({
	children,
	params,
}: React.PropsWithChildren<DeliveryLayoutProps>) {
	return <DeliveryProvider placeId={params.placeId}>{children}</DeliveryProvider>;
}

export default observer(DeliveryLayout);
